import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import api from "@/api";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  },
});

const PUBLIC_ROUTES = ["/login", "/register", "/recuperar", "/aceitar-convite"];
const SETUP_ROUTE = "/setup";
const SKIP_SETUP = [
  "/login",
  "/register",
  "/recuperar",
  "/aceitar-convite",
  "/setup",
];

const STAFF_BLOCKED = [
  "/clientes/descontos",
  "/campanhas/criar",
  "/campanhas/templates",
  "/campanhas/historico",
  "/definicoes",
  "/categorias",
  "/restaurantes",
  "/staff",
  "/sync",
];

const MANAGER_BLOCKED = ["/restaurantes", "/sync"];

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("tokenAbitue");

  // Sem token → só pode ir para rotas públicas
  if (!token) {
    if (PUBLIC_ROUTES.includes(to.path)) return next();
    return next("/login");
  }

  // Com token → não precisa de ir para login/register
  // Exceção: aceitar-convite é sempre acessível
  if (PUBLIC_ROUTES.includes(to.path)) {
    if (to.path === "/aceitar-convite") return next();
    return next("/dashboard");
  }

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  // Guards de role — correm ANTES do SKIP_SETUP para não serem bypassados
  if (user.role === "staff") {
    if (STAFF_BLOCKED.includes(to.path)) return next("/dashboard");
  }

  if (user.role === "manager") {
    if (MANAGER_BLOCKED.includes(to.path)) return next("/dashboard");
  }

  // Já está no setup ou noutras rotas excluídas → deixa passar
  if (SKIP_SETUP.includes(to.path)) return next();

  // Staff e managers nunca precisam de fazer setup
  if (user.role === "staff" || user.role === "manager") return next();

  // Verificar se o owner tem restaurantes (só uma vez por sessão)
  if (!router._setupChecked) {
    try {
      const { data } = await api.get("/restaurantes/setup-status");
      router._setupChecked = true;
      router._temRestaurantes = data.tem_restaurantes;

      if (!data.tem_restaurantes) return next(SETUP_ROUTE);
    } catch {
      router._setupChecked = true;
      router._temRestaurantes = true;
    }
  } else if (!router._temRestaurantes) {
    return next(SETUP_ROUTE);
  }

  next();
});

router.afterEach(() => {
  const token = localStorage.getItem("tokenAbitue");
  if (!token) {
    router._setupChecked = false;
    router._temRestaurantes = false;
  }
});

export default router;
